import type { PptxShape } from './pptxParser';
const P = 'http://schemas.openxmlformats.org/presentationml/2006/main';
const A = 'http://schemas.openxmlformats.org/drawingml/2006/main';
const R = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships';
const child = (el: Element, ns: string, name: string) => Array.from(el.children).find(item => item.namespaceURI === ns && item.localName === name);
/** Edit only picture source/crop. Keep its native transform, mask, effects, alt text and remaining metadata. */
export function patchPptxImageProperties(doc: Document, pic: Element, shape: PptxShape, synthetic = false): void {
  if (shape.type !== 'image' || pic.localName !== 'pic' || (!synthetic && !shape.imageCropDirty && !shape.imageSourceDirty)) return;
  let fill = child(pic, P, 'blipFill');
  if (!fill) { fill = doc.createElementNS(P, 'p:blipFill'); pic.insertBefore(fill, child(pic, P, 'spPr') ?? null); }
  let blip = child(fill, A, 'blip');
  if (!blip) { blip = doc.createElementNS(A, 'a:blip'); fill.insertBefore(blip, fill.firstChild); }
  if (shape.imageSourceDirty && shape.imageRId) {
    blip.setAttributeNS(R, 'r:embed', shape.imageRId); blip.removeAttributeNS(R, 'link');
    // An old SVG alternative would otherwise override the newly selected bitmap in PowerPoint.
    for (const alternative of Array.from(blip.getElementsByTagName('*')).filter(el => el.localName === 'svgBlip')) alternative.remove();
  }
  if (shape.imageCropDirty || synthetic) {
    for (const existing of Array.from(fill.children).filter(el => el.namespaceURI === A && el.localName === 'srcRect')) existing.remove();
    if (shape.imageCrop && Object.values(shape.imageCrop).some(value => value !== 0)) {
      const crop = doc.createElementNS(A, 'a:srcRect');
      for (const [key, attribute] of [['left', 'l'], ['top', 't'], ['right', 'r'], ['bottom', 'b']] as const) crop.setAttribute(attribute, String(Math.round(shape.imageCrop[key])));
      fill.insertBefore(crop, blip.nextSibling);
    }
  }
}
